const initialState = {
  republicanSeats: 0,
  republicanSeatsChanged: 0,
  democratSeats: 0,
  democratSeatsChanged: 0,
  controllingParty: "democratic",
};

const mutations = {
  SET_REPUBLICAN_SEATS(state, republicanSeats) {
    state.republicanSeats = republicanSeats;
  },
  SET_REPUBLICAN_SEATS_CHANGED(state, republicanSeatsChanged) {
    state.republicanSeatsChanged = republicanSeatsChanged;
  },
  SET_DEMOCRAT_SEATS(state, democratSeats) {
    state.democratSeats = democratSeats;
  },
  SET_DEMOCRAT_SEATS_CHANGED(state, democratSeatsChanged) {
    state.democratSeatsChanged = democratSeatsChanged;
  },
  SET_CONTROLLING_PARTY(state, controllingParty) {
    state.controllingParty = controllingParty;
  },
};

const actions = {
  fetchCongressControl(context, dataURL) {
    fetch(`${process.env.VUE_APP_S3_API_URL}${dataURL}`)
      .then((response) => {
        if (!response.ok)
          throw new Error("Unable to fetch congress control data: ", response.status);

        try {
          return response.json();
        } catch {
          throw new Error("Unable to parse congress control JSON response body.");
        }
      })
      .then((congressControlData) => {
        context.commit("SET_REPUBLICAN_SEATS", congressControlData.republican_current_seats);
        context.commit(
          "SET_REPUBLICAN_SEATS_CHANGED",
          congressControlData.republican_net_changed_seats
        );
        context.commit("SET_DEMOCRAT_SEATS", congressControlData.democratic_current_seats);
        context.commit(
          "SET_DEMOCRAT_SEATS_CHANGED",
          congressControlData.democratic_net_changed_seats
        );
        context.commit("SET_CONTROLLING_PARTY", congressControlData.controlling_party);
      })
      .catch((error) => console.error(error));
  },
};

const getters = {
  republicanSeats(state) {
    return state.republicanSeats;
  },
  republicanSeatsChanged(state) {
    return state.republicanSeatsChanged;
  },
  democratSeats(state) {
    return state.democratSeats;
  },
  democratSeatsChanged(state) {
    return state.democratSeatsChanged;
  },
  controllingParty(state) {
    return state.controllingParty;
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
